import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { appStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useYardSetupMessageHandler } from '../../hooks/useYardSetupMessageHandler'
import { ISpaceBetweenBaysConfigAreaFormData } from '../../models/yard-setup.model'
import { YardBlockViewStore } from '../../stores/nodes/yard-block.view-store'
import { SpaceBetweenBaysConfigAreaForm } from './SpaceBetweenBaysConfigAreaForm'

interface Props {
  yardBlockViewStore: YardBlockViewStore
}

export const YardBlockSpaceBetweenBaysDialog = observer(({ yardBlockViewStore }: Props) => {
  const { t } = useTranslate()
  const { getExceptionMessage, getBlockSuccessMessage } = useYardSetupMessageHandler()

  const onSubmit = async (data: ISpaceBetweenBaysConfigAreaFormData) => {
    try {
      await yardBlockViewStore.addCurrentSpaceBetweenBays(data)
      appStore.setShowAlert('success', getBlockSuccessMessage(true))
      yardBlockViewStore.closeSpaceBetweenBaysDialog()
    } catch (e: any) {
      appStore.setShowAlert('error', getExceptionMessage(e))
    }
  }

  return (
    <ConfirmationDialog
      open={yardBlockViewStore.isSpaceBetweenBaysDialogOpen}
      title={t('addSpaceAfterBay', 'Add space after bay')}
      primaryActionText={t('save', 'Save')}
      closeLabel={t('cancel', 'cancel')}
      formId='space-between-bays-config-area-form'
      onClose={() => yardBlockViewStore.closeSpaceBetweenBaysDialog()}
      onConfirm={() => {
        return
      }}
      maxWidth='xs'
    >
      <SpaceBetweenBaysConfigAreaForm
        id='space-between-bays-config-area-form'
        onSubmit={onSubmit}
      />
    </ConfirmationDialog>
  )
})
